import { SxProps, Typography, Stack, tokens } from '@cast/design-system';

import { formatDailyMetricsCost } from '../../../../cost-report/utils/metrics/formatDailyMetricsCost';

type Props = {
  title: string;
  value?: number;
  unit?: string;
  sx?: SxProps;
  testId?: string;
};

export const Metric = ({ title, value, unit, sx, testId }: Props) => {
  return (
    <Stack
      direction="row"
      flexWrap="nowrap"
      alignItems="baseline"
      justifyContent="space-between"
      gap={8}
      sx={sx}
      data-testid={testId}
    >
      <Typography variant="L10R">{title}</Typography>
      <Stack direction="row" alignItems="baseline" gap={4}>
        <Typography variant="h6">{formatDailyMetricsCost(value)}</Typography>
        <Typography variant="L10R" color={tokens.theme.fg.structural.secondary}>
          /{unit}
        </Typography>
      </Stack>
    </Stack>
  );
};
